import { extractData, getShowroomAll } from "api"
import { trackBuildMazdaCTA } from "common/analytics"
import { keepOnlyUtmParams } from "common/bit/utils/utmParams"
import { buildShopLink } from "common/buildShopLink"
import { useRouter } from "next/dist/client/router"
import { useEffect, useState } from "react"
import ButtonBaseBlank from "reusable/ButtonBaseBlank"
import { useTypedSelector } from "store"
import styled from "styled-components"
import colors from "theme/colors"
import { StyledRow, StyledSvgIcon, TypographyCenter } from "theme/shared"
import PurchaseToolsPopup from "../popups/purchaseTools/PurchaseToolsPopup"
import TestDrivePopup from "../popups/testDrive/TestDrivePopup"

const StyledWrapper = styled.div`
  background-color: ${(p) => p.theme.colors.transparent};
  position: sticky;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  padding: 20px;
  z-index: 100;
`
const StyledCard = styled.div`
  background-color: ${(p) => p.theme.colors.white};
  width: 100%;
  padding: 4px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  max-width: 320px;
  margin: 0 auto;
`
const StyledButtonBaseBlank = styled(ButtonBaseBlank)`
  border-radius: 3px;
  height: 45px;
  width: 100%;
`
const StyledFakeButton = styled.div<{ $dark?: boolean }>`
  background-color: ${(p) =>
    p.$dark ? p.theme.colors.black : p.theme.colors.white};
  border-radius: 3px;
  height: 45px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

type Props = {
  setPopupOpen?: (falsy: boolean) => void
  numberOfFinishingLevels: number
  modelId: number
}

const StickyBottomCTA = ({
  setPopupOpen,
  numberOfFinishingLevels,
  modelId,
}: Props) => {
  const [testDrivePopupOpen, setTestDrivePopupOpen] = useState(false)
  const [purchaseToolsPopupOpen, setPurchaseToolsPopupOpen] = useState(false)
  const [showRoomsList, setShowRoomList] = useState([])
  const [utmParams, setUtmParams] = useState("")

  const detailData = useTypedSelector((state) => state?.detailing)

  const { detailing, color } = detailData

  const shopUrl = `${buildShopLink(detailing, color, modelId, utmParams)}`
  const router = useRouter()

  useEffect(() => {
    let isComponentMounted = true
    const fetchData = async () => {
      if (isComponentMounted) {
        const data = await getShowroomAll(null, null).then(extractData)
        setShowRoomList(data?.body)
      }
    }
    fetchData().catch(console.error)

    setUtmParams(
      keepOnlyUtmParams(
        window.location.href.split("?")[1] || "" || window.location.search
      )
    )

    return () => {
      isComponentMounted = false
    }
  }, [])

  return (
    <>
      <StyledWrapper>
        <StyledCard>
          <StyledRow $fullWidth $gap="2px">
            <StyledButtonBaseBlank
              onClick={() => setPurchaseToolsPopupOpen(true)}
              role="button"
            >
              <StyledFakeButton>
                <StyledRow $fullWidth $justify="center" $gap="4px">
                  <TypographyCenter variant="body2">
                    לפעולות נוספות
                  </TypographyCenter>
                  <StyledSvgIcon
                    src={`/icons/fi_chevron-down.svg`}
                    alt="downArrow"
                    w={18}
                    h={18}
                  />
                </StyledRow>
              </StyledFakeButton>
            </StyledButtonBaseBlank>

            <StyledButtonBaseBlank
              onClick={() => {
                trackBuildMazdaCTA(), router.push(shopUrl)
              }}
            >
              <StyledFakeButton $dark>
                <TypographyCenter variant="body2" $color={colors.white}>
                  להרכבת המאזדה שלך
                </TypographyCenter>
                <TypographyCenter variant="caption" $color={colors.darkGrey}>
                  {`${numberOfFinishingLevels} רמות גימור לבחירה`}
                </TypographyCenter>
              </StyledFakeButton>
            </StyledButtonBaseBlank>
          </StyledRow>
        </StyledCard>
      </StyledWrapper>
      <PurchaseToolsPopup
        setPopupOpen={setPopupOpen}
        open={purchaseToolsPopupOpen}
        onClose={() => setPurchaseToolsPopupOpen(false)}
        openTestDrivePopup={(openForm) => {
          if (openForm) {
            setTestDrivePopupOpen(true)
          }
          setPurchaseToolsPopupOpen(false)
        }}
        modelId={modelId}
        shopUrl={shopUrl}
        numberOfFinishingLevels={numberOfFinishingLevels}
      />
      <TestDrivePopup
        open={testDrivePopupOpen}
        onClose={() => setTestDrivePopupOpen(false)}
        showRoomsList={showRoomsList}
        modelId={modelId}
        formType="test-drive"
        title="תיאום נסיעת מבחן"
        dialogClass="mobile-margin"
      />
    </>
  )
}

export default StickyBottomCTA
